import styled from 'styled-components'
import {Card as ACard, Menu} from 'antd'


export const Card = styled(ACard)`
    height: 95vh;

    .ant-card-body {
        height: 100%;
    }

`

export const CustomMenu = styled(Menu)`
    .ant-menu-item:hover {

    }
    
    .ant-menu {
        overflow-y: auto;
        height: calc(100% - 60px)
    }

    .ant-menu-title-content {
        display: inline-flex;
        justify-content: space-between;
        align-items: center;
        width: calc(100% - 24px);

        .action-icon {
            display: none;
        }
    }

    .ant-menu-item-selected {
        .action-icon {
            display: flex;
        }

        .ant-menu-title-content {
            font-weight: bold;
        }
    }
`